import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { EmptyObject } from 'apollo-angular/types';
import { DocumentNode } from 'graphql';
import { Subscription } from 'rxjs';
import { LoadingService } from '../services/loading.service';

@Injectable()
export abstract class Container<T> implements OnDestroy {
  public queryRef: QueryRef<T>;
  public querySubscription: Subscription;

  constructor(
    private apollo: Apollo,
    protected loadingService: LoadingService,
    @Inject('query') protected query: DocumentNode,
    @Inject('env') private environment: any
  ) {}

  subscribeToQuery(variables?: EmptyObject | undefined): void {
    this.loadingService.setLoading(true);
    if (!this.queryRef) {
      this.queryRef = this.apollo.watchQuery<T>({
        query: this.query,
        fetchPolicy: 'network-only',
        context: { __skipErrorAccordingCache__: true },
        errorPolicy: 'all',
        pollInterval: this.environment.pollingIntervall,
        variables: variables ? variables : undefined,
      });
    }
    this.querySubscription = this.queryRef.valueChanges.subscribe(
      (result) => {
        if (
          result.data &&
          result.networkStatus !== 2 &&
          result.networkStatus !== 4
        ) {
          this.handleSubscriptionResult(result.data);
          if (result.networkStatus === 7) {
            this.loadingService.setLoading(false);
          }
        }
        if (result.errors) {
          for (let error of result.errors) {
            // AppComponent.APM.captureError(error);
          }
        }
      },
      (error) => {
        this.loadingService.setLoading(false);
      }
    );
  }

  abstract handleSubscriptionResult(data: T): any;

  ngOnDestroy(): void {
    this.querySubscription?.unsubscribe();
  }
}
